import { SubCasteContext } from "./SubCasteContext";
import { useContext } from "react";

export const useSubCasteContext = () => {
    const context = useContext(SubCasteContext);
    if(!context){
        throw Error("useSubCasteContext should be used inside SubCasteContextProvidor");
    }
    return context;
}